import { ReactRenderer } from "@tiptap/react";
import { SuggestionOptions } from "@tiptap/suggestion";
import tippy, { Instance, Props } from "tippy.js";
import { SimpleLiquidSuggestion, SimpleLiquidSuggestionProps } from "./liquid-suggestion-menu";

const renderLiquidOptions: SuggestionOptions["render"] = () => {
  let component: ReactRenderer<unknown, SimpleLiquidSuggestionProps>;
  let popup: Instance<Props>;

  return {
    onStart: ({ editor, query, ...props }) => {
      component = new ReactRenderer(SimpleLiquidSuggestion, {
        props: {
          ...props,
          isVisible: true,
          items: props.items,
          onSelect: (tag) => {
            editor.chain().focus().deleteRange(props.range).insertContent(`{{ ${tag.tag} }}`).run();
            editor.view.focus();
            if (popup && popup.state.isMounted) {
              popup.hide();
            }
          },
          onClose: () => {
            if (popup && popup.state.isMounted) {
              popup.hide();
            }
          },
          query,
        } as SimpleLiquidSuggestionProps,
        editor,
      });

      popup = tippy(document.querySelector('[role="dialog"]') || document.body, {
        getReferenceClientRect: () => props.clientRect!()!,
        appendTo: () => document.querySelector('[role="dialog"]') || document.body,
        content: component.element,
        showOnCreate: true,
        interactive: true,
        trigger: "manual",
        placement: "bottom-start",
      });

      console.log("popup created", popup);
    },
    onUpdate(props) {
      component.updateProps(props);
      if (popup && popup.state.isMounted) {
        popup.setProps({
          getReferenceClientRect: () => props.clientRect!()!,
        });
      }
    },
    onKeyDown(props) {
      if (props.event.key === "Escape") {
        if (popup && popup.state.isMounted) {
          popup.hide();
        }

        return true;
      }

      return false;
    },
    onExit() {
      if (popup && popup.state.isMounted) {
        popup.destroy();
      }
      component.destroy();
    },
  };
};

export default renderLiquidOptions;
